import { supabase } from "@/lib/supabaseClient";

export async function registerTutorAccount(accessToken?: string): Promise<void> {
  let token = accessToken;

  if (!token) {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();

    if (error || !session?.access_token) {
      throw error || new Error("A signed-in account is required");
    }
    token = session.access_token;
  }

  const response = await fetch("/api/teacher/register", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error("Tutor account registration failed");
  }
}
